import type NumberUnit from '@exodus/currency';
import { useSelector } from 'react-redux';

import selectors from '../flux/selectors.js';

const useConversion = (assetName: string) =>
  useSelector<unknown, (value: NumberUnit) => NumberUnit>((state) =>
    assetName
      ? selectors.fiatBalances.createAssetConversion(assetName)(state)
      : null,
  );

export default useConversion;
